import type { FaireProductEntity } from "../../entity_types/product";

export const p_333c9py5wu: FaireProductEntity = {
  token: "p_333c9py5wu",
  type: "product",
  name: "Ritzy Rattle™ Silicone Teether Rattles",
  brandToken: "b_df9cebde",
  brandName: "Itzy Ritzy",
  imageUrl: "https://cdn.faire.com/fastly/446fceb0c7047fce882bda4b844a4bbbd468de61e17561dc6e9280ba26a670fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d18d530d8248689bc80d37def69fdd0b2ff9b1fa3afb43c94b651effb58cbafd.jpeg",
    "https://cdn.faire.com/fastly/97faee7d897ad38033e1c1bed0a4b24174d5cf035d8fde0085fdf626c84554e0.jpeg",
    "https://cdn.faire.com/fastly/25f6dbbac98722a4df271d6b22b19738c3a6a1670e2808fae18115fe10d1529b.jpeg",
    "https://cdn.faire.com/fastly/e6f702883425bd64f4e5075ef58ad3f2003067be3fd1499bcc2e65a46711214c.png",
    "https://cdn.faire.com/fastly/d513ea3f3437b6e45a5eff267aec787999d210470fadf017dcce79d3b2b2ef8d.jpeg",
    "https://cdn.faire.com/fastly/0cc56e47d2d995e8f4538dfb40d7bdcbc41175760afaf5b081fcce6e461091d9.jpeg",
    "https://cdn.faire.com/fastly/fb54c3abcd355d330dfc7a5ad954f6528d44c0fe54aed76b89f69a21d7cd357d.png",
    "https://cdn.faire.com/fastly/bb5d962597978c2b8986dde2c6115c1c45b7dd473ffc15dbc6b372c271eef7ec.jpeg",
    "https://cdn.faire.com/fastly/c171104173e8870ac40abb9d172c719650ff8013665881ed102b8e8d25b16894.jpeg",
    "https://cdn.faire.com/fastly/cb20194c7d56369c48099b2c34830dedf521e00131b0150243c0ff887458799f.jpeg",
    "https://cdn.faire.com/fastly/94ea3685403811f90f4ce40c3cf624f66fc4888c233abb2db80e4876a230d2b2.png",
    "https://cdn.faire.com/fastly/c3282cead7b575761493412bf424b68552063f2122d5aa1648d7ab1a6a907778.jpeg",
    "https://cdn.faire.com/fastly/5ed01a299fe35995fba1b79c1e1eb9d4acebd88573ab775e647d19688aa9f267.jpeg",
    "https://cdn.faire.com/fastly/9cf9afdc09fd84f25fce6846affdd1157aeab7e9ff66c0d9cab9960f0affeb75.jpeg"
  ],
  priceDollars: 5,
  description: "Shake the teething blues away with an adorable Ritzy Rattle™! Our silicone rattle teether features a gentle rattle sound and includes two silicone rings to keep baby’s hands busy. The rattle teether is easy for baby to grasp and its raised textures will help soothe and massage sore gums. The Ritzy Rattle™ is designed for ages 3 months and up and coordinates beautifully with our Sweetie Soothers™ silicone pacifiers.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:37.142Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
